export enum GameAnalysisPhysicalStatus {
	INITIAL = "Initial",
	PENDING_TAGGING = "Pending-Tagging",
	REQUESTED = "Requested",
	IN_PROGRESS = "In-Progress",
	REVIEW = "Review",
	DONE = "Done",
	REJECTED = "Rejected",
}
